import React, { useState, useEffect } from 'react';
import { Modal, Progress } from 'components/shared/AntComponent';
import { useSelector } from 'react-redux';
const QuestionFile:any = "/files/question_sample.xlsx";
interface ChildProps {
    openModal: boolean;
    mid: any;
    closeModal: () => void;
}

const SampleFileModal: React.FC<ChildProps> = ({ openModal, closeModal, mid }) => {
    const { loading5, sfileInfo } = useSelector((state: any) => state.account);
    const downloadProgress = useSelector((state: any) => state.download.downloadProgress);

    const handleDownloadLocal = () => {
        const link = document.createElement("a");
        link.href = QuestionFile;
        link.download = mid === 1
            ? "applicant_sample_file.xlsx"
            : "question_sample_file.xlsx";
        link.click();
    };

    useEffect(() => {
        if (openModal) {
            handleDownloadLocal();
            closeModal();
        }
    }, [openModal]);

    const handleCancel = () => {
        closeModal();
    }

    const conicColors = {
        '0%': '#87d068',
        '50%': '#ffe58f',
        '100%': '#ffccc7',
    };
    return (
        <div>
            <Modal open={openModal} maskClosable={false} onCancel={handleCancel} title={mid == 1 ? "Sample Applicant File" : "Sample Question File"} footer={null}>
                <div className='d-flex align-items-center justify-content-center'>
                    <Progress type="circle" percent={downloadProgress} strokeColor={conicColors} />
                </div>
            </Modal>
        </div>
    )
}

export default SampleFileModal;